import { createFileRoute } from "@tanstack/react-router";

import { OnboardingProfile } from "../../../features/onboarding/OnboardingProfile";

export const Route = createFileRoute("/_app/onboarding/profile")({
  component: OnboardingProfile,
});
